import React from "react";
import "./Line.css";

export default function Line() {
  return (
    <section className="lineWrap-lnd">
      <div className="lineInner-lnd">
        {/* La ligne */}
        <div className="lineBar-lnd" aria-hidden="true" />

        {/* Actions à droite */}
        <div className="lineActions-lnd">
          <button className="lineChip-lnd" type="button">
            Disponible 24h/24 et 7j/7
          </button>

          <button className="lineCircle-lnd" type="button" aria-label="Next">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 7l5 5-5 5"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
}
